import {PaymentCurrencyType} from "@irati/types"
import {formatCurrency} from "@irati/utils/currency/formatCurrency"

const getTotalSavings = (props, currencyCode, formatValue = false) => {
  const isPerkSavingEstimated = props.type === "% discount voucher" || props.type === "discount voucher"
  let value

  if (isPerkSavingEstimated) {
    if (currencyCode === PaymentCurrencyType.Gbp && props.estimatedSavingsGBP > 0) {
      value = props.estimatedSavingsGBP
    } else if (currencyCode === PaymentCurrencyType.Aud && props.estimatedSavingsAUD > 0) {
      value = props.estimatedSavingsAUD
    }
  } else {
    if (props.savingsPercentage > 0) {
      if (formatValue) {
        return `${props.savingsPercentage.toFixed(2)}%`
      }
      return props.savingsPercentage.toFixed(2)
    }

    if (currencyCode === PaymentCurrencyType.Gbp && props.savingsGBP > 0) {
      value = props.savingsGBP
    } else if (currencyCode === PaymentCurrencyType.Aud && props.savingsAUD > 0) {
      value = props.savingsAUD
    }
  }

  if (value) {
    if (formatValue) {
      const formattedValue = formatCurrency({isCents: false, currencyCode, value})
      return isPerkSavingEstimated ? `${formattedValue}*` : formattedValue
    }
    const fixedValue = value.toFixed(2)
    return isPerkSavingEstimated ? `${fixedValue}` : fixedValue
  }
  return "-"
}

export default getTotalSavings
